module.exports = __webpack_public_path__ + "media/images/bodega-4a0ca91971b43b3c73ef33ac65735503.jpg";